import {ClientCategorie, ClientCategorieDto} from './client-categorie';
import {Dienst} from '../dienst/dienst';

export class ClientDienst {

  static deserialize(dto: ClientDienstDto): ClientDienst {
    return new ClientDienst(
      dto.id,
      dto.categorieen.map(categorieDto => ClientCategorie.deserialize(categorieDto)),
      dto.zoneId,
    );
  }

  static new(dienst: Dienst, clientZoneId: string): ClientDienst {
    return new ClientDienst(
      dienst.getId(),
      dienst.getCategorieenWithStandaardTaken().map(categorie => ClientCategorie.new(categorie)),
      clientZoneId,
    );
  }

  constructor(
    private id: string,
    private categorieen: Array<ClientCategorie>,
    private zoneId: string,
  ) {
  }

  getId(): string {
    return this.id;
  }

  hasId(id: string): boolean {
    return this.id === id;
  }

  hasCategorie(id: string): boolean {
    return !!this.categorieen.find(categorie => categorie.hasId(id));
  }

  getCategorie(id: string): ClientCategorie {
    if (!this.hasCategorie(id)) {
      this.categorieen.push(ClientCategorie.empty(id));
    }
    return this.categorieen.find(categorie => categorie.hasId(id));
  }

// TODO get rid of setter

  setZoneId(zoneId: string) {
    return this.zoneId = zoneId;
  }

  getZoneId(): string {
    return this.zoneId;
  }
}

export class ClientDienstDto {
  id: string;
  categorieen: Array<ClientCategorieDto>;
  zoneId: string;
}
